import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=49532be2&scoped=true&"
import script from "./SignUpPage.vue?vue&type=script&lang=js&"
export * from "./SignUpPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49532be2",
  null
  
)

export default component.exports